export default "__VITE_ASSET__Dhob$b2E__"